import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';
import authorPortrait from '../../assets/images/author_portrait.webp';
import pic1 from '../../assets/images/pic-1.webp';
import pic2 from '../../assets/images/pic-2.webp';
import pic3 from '../../assets/images/pic-3.webp';
import pic4 from '../../assets/images/pic-4.webp';
import pic5 from '../../assets/images/pic-5.webp';
import pic6 from '../../assets/images/pic-6.webp';
import pic7 from '../../assets/images/pic-7.webp';
import ctabg from '../../assets/images/cta-bg.webp';
import { CategoryService } from '../../services/api.services';
import config from '../../config/config';
import { getCategoryImage } from '../../utils/categoryImages';

/* ── Gallery slides ── */
const gallerySlides = [pic3, pic4, pic5, pic6, pic7];

/* ── FAQ items ── */
const faqs = [
  {
    q: 'Photographic equipment that I usually use',
    answer: (
      <div className="ab-faq-answer-detail">
        <p>Camera: Canon 5D III</p>
        <p>
          Lens: 50mm f / 1.2L, 85mm f / 1.2L, 24 – 70mm f / 2.8L
        </p>
        <p>Post-production: Lightroom / Photoshop</p>
        <p>Mobile: iPhone X + VSCO Cam + Snapseed</p>
      </div>
    ),
  },
  {
    q: 'How to start as a food blogger?',
    answer: (
      <p>
        Start with passion, invest in a decent camera, learn basic food styling,
        write consistently, and engage with your audience. The most important
        ingredient is authenticity!
      </p>
    ),
  },
  {
    q: 'When is the workshop open this year',
    answer: (
      <p>
        Workshops are held twice a year — Spring (April–May) and Autumn
        (September–October). Follow my Instagram for exact dates and booking
        links.
      </p>
    ),
  },
];

const AboutPage: React.FC = () => {
  const [slideIdx, setSlideIdx] = useState(0);
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [topCategories, setTopCategories] = useState<Array<{ img: string, label: string }>>([]);

  React.useEffect(() => {
    CategoryService.getAll()
      .then(res => {
        if (res.success && res.data) {
          // Sort by count descending and take top 3
          const top3 = res.data.sort((a, b) => b.count - a.count).slice(0, 3);
          const formatted = top3.map((c, index) => {
            const fallbackImages = [pic1, pic2, pic3, pic4, pic5, pic6, pic7];
            return {
              label: c.name,
              img: fallbackImages[index % fallbackImages.length]
            };
          });
          setTopCategories(formatted);
        }
      })
      .catch(console.error);
  }, []);

  const toggleLightbox = () => setIsLightboxOpen(!isLightboxOpen);

  const prevSlide = () =>
    setSlideIdx((p) => (p - 1 + gallerySlides.length) % gallerySlides.length);
  const nextSlide = () =>
    setSlideIdx((p) => (p + 1) % gallerySlides.length);

  return (
    <main className="about-page">

      {/* ── 1. HERO ── */}
      <section
        className="ab-hero"
        style={{ backgroundImage: `url("${authorPortrait}")` }}
      >
        <div className="ab-hero-overlay" />
        <div className="ab-hero-content">
          <p className="ab-hero-label">HELLO. I AM Loganayaki Thamilselvan.</p>
          <h1 className="ab-hero-heading">
            Food stylist &amp; photographer. Loves nature<br />
            and healthy food, and good coffee.
          </h1>
          <p className="ab-hero-signature">Loganayaki Thamilselvan</p>
        </div>
      </section>

      {/* ── 2. STORY SECTION ── */}
      <section className="ab-story">
        <div className="ab-story-inner">
          <h2 className="ab-story-title">Story behind this food blog</h2>
          <p className="ab-story-para">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet
            cursus sit amet dictum sit amet. Pellentesque habitant morbi
            tristique senectus et netus et malesuada. Eu sem integer vitae justo
            eget magna fermentum iaculis eu.
          </p>
          <p className="ab-story-para">
            Nunc id cursus metus aliquam eleifend mi in. Urna porttitor rhoncus
            dolor purus non enim. In nulla posuere sollicitudin aliquam ultrices.
            Metus vulputate eu scelerisque felis imperdiet proin fermentum.
            Tempor orci eu lobortis elementum nibh tellus molestie nunc. Tristique
            sollicitudin nibh sit amet. Ut porttitor leo a diam sollicitudin. Dolor
            morbi non arcu risus quis varius. Et malesuada fames ac turpis egestas
            maecenas pharetra convallis. Cursus sit amet dictum sit. Purus sit amet
            luctus venenatis lectus magna.
          </p>
          <p className="ab-story-para">
            Sagittis aliquam malesuada bibendum arcu vitae elementum curabitur.
            Feugiat nibh sed pulvinar proin gravida hendrerit lectus. Nulla aliquet
            porttitor lacus luctus accumsan tortor. Morbi non arcu risus quis
            varius quam quisque id. Interdum consectetur libero id faucibus nisl
            tincidunt. Scelerisque purus semper eget duis.
          </p>
        </div>
      </section>

      {/* ── 3. GALLERY SLIDER ── */}
      <section className="ab-gallery">
        <div className="ab-gallery-inner">
          <div className="ab-gallery-track">
            <img
              src={gallerySlides[slideIdx]}
              alt={`Gallery slide ${slideIdx + 1}`}
              className="ab-gallery-img"
            />
            <button
              className="ab-gallery-arrow ab-gallery-arrow--left"
              onClick={prevSlide}
              aria-label="Previous image"
            >
              &#8249;
            </button>
            <button
              className="ab-gallery-arrow ab-gallery-arrow--right"
              onClick={nextSlide}
              aria-label="Next image"
            >
              &#8250;
            </button>
            {/* expand icon */}
            <button className="ab-gallery-expand" aria-label="Fullscreen" onClick={toggleLightbox}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15 3 21 3 21 9" />
                <polyline points="9 21 3 21 3 15" />
                <line x1="21" y1="3" x2="14" y2="10" />
                <line x1="3" y1="21" x2="10" y2="14" />
              </svg>
            </button>
          </div>
          <div className="ab-gallery-dots">
            {gallerySlides.map((_, i) => (
              <button
                key={i}
                className={`ab-gallery-dot ${i === slideIdx ? 'active' : ''}`}
                onClick={() => setSlideIdx(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ── 4. FAQ + PHOTO (dark section) ── */}
      <section className="ab-faq-section">
        <div className="ab-faq-inner">
          {/* Left photo */}
          <div className="ab-faq-photo">
            <img src={pic4} alt="Cooking preparation" />
          </div>

          {/* Right FAQ */}
          <div className="ab-faq-content">
            <h2 className="ab-faq-heading">Frequently Asked Questions</h2>
            <div className="ab-faq-list">
              {faqs.map((item, i) => (
                <div
                  key={i}
                  className={`ab-faq-item ${openFaq === i ? 'open' : ''}`}
                >
                  <button
                    className="ab-faq-question"
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    aria-expanded={openFaq === i}
                  >
                    <span>{item.q}</span>
                    <span className="ab-faq-icon">
                      {openFaq === i ? '−' : '+'}
                    </span>
                  </button>
                  {openFaq === i && (
                    <div className="ab-faq-answer">{item.answer}</div>
                  )}
                </div>
              ))}
            </div>
            <p className="ab-faq-cta">
              Wanna know more?{' '}
              <Link to="/contact/#">Contact us</Link>
            </p>
          </div>
        </div>
      </section>

      {/* ── 5. MORE TEXT ── */}
      <section className="ab-more-text">
        <div className="ab-more-text-inner">
          <p className="ab-story-para">
            Nunc id cursus metus aliquam eleifend mi in. Urna porttitor rhoncus
            dolor purus non enim. In nulla posuere sollicitudin aliquam ultrices.
            Metus vulputate eu scelerisque felis imperdiet proin fermentum.
            Tempor orci eu lobortis elementum nibh tellus molestie nunc. Tristique
            sollicitudin nibh sit amet. Ut porttitor leo a diam sollicitudin. Dolor
            morbi non arcu risus quis varius. Et malesuada fames ac turpis egestas
            maecenas pharetra convallis. Cursus sit amet dictum sit. Purus sit amet
            luctus venenatis lectus magna.
          </p>
          <p className="ab-story-para">
            Ipsum dolor sit amet consectetur adipiscing elit. Enim sit amet
            venenatis urna cursus eget nunc scelerisque. In hac habitasse platea
            dictumst. Auctor neque vitae tempus quam pellentesque. Tristique
            sollicitudin nibh sit amet. Ut porttitor leo a diam sollicitudin.
            Dolor morbi non arcu risus quis varius. Et malesuada fames ac turpis
            egestas maecenas pharetra convallis.
          </p>
          <p className="ab-story-para">
            Dolor morbi non arcu risus quis varius. Et malesuada fames ac turpis
            egestas maecenas pharetra convallis. Cursus sit amet dictum sit.
            Purus sit amet luctus venenatis lectus magna.
          </p>
        </div>
      </section>

      {/* ── 6. QUOTE BANNER ── */}
      <section
        className="ab-quote-banner"
        style={{ backgroundImage: `url("${ctabg}")` }}
      >
        <div className="ab-quote-overlay" />
        <div className="ab-quote-content">
          <div className="ab-quote-icon">&#8220;</div>
          <blockquote className="ab-quote-text">
            Cooking is about passion, so it may look slightly temperamental
            in a way that it&apos;s too assertive to the naked eye.
          </blockquote>
          <p className="ab-quote-author">GORDON RAMSAY</p>
        </div>
      </section>

      {/* ── 7. THANK YOU + CATEGORY CARDS ── */}
      <section className="ab-thankyou">
        <div className="ab-thankyou-inner">
          <h2 className="ab-thankyou-title">Thank you for reading</h2>
          <p className="ab-story-para">
            Ipsum dolor sit amet consectetur adipiscing elit. Enim sit amet
            venenatis urna cursus eget nunc scelerisque. In hac habitasse platea
            dictumst. Auctor neque vitae tempus quam pellentesque. Tristique
            sollicitudin nibh sit amet. Ut porttitor leo a diam sollicitudin.
            Dolor morbi non arcu risus quis varius. Et malesuada fames ac turpis
            egestas maecenas pharetra convallis.
          </p>
          <p className="ab-story-para">
            Metus vulputate eu scelerisque felis imperdiet proin fermentum. Et
            malesuada fames ac turpis egestas maecenas pharetra convallis.
            Cursus sit amet dictum sit. Purus sit amet luctus venenatis lectus
            magna!
          </p>
          <p className="ab-story-para">
            Do you have questions about recipes? Wanna work together? Feel free
            to write to me for all inquires!
          </p>

          {/* Category cards */}
          <div className="ab-cat-cards">
            {topCategories.map((card, i) => (
              <div className="ab-cat-card" key={i}>
                <div className="ab-cat-card-img-wrap">
                  <img src={card.img} alt={card.label} />
                  <div className="ab-cat-card-overlay" />
                </div>
                <p className="ab-cat-card-label">{card.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── LIGHTBOX ── */}
      {isLightboxOpen && (
        <div className="ab-lightbox" onClick={toggleLightbox}>
          <div className="ab-lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={gallerySlides[slideIdx]} alt="Fullscreen view" className="ab-lightbox-img" />
            <button className="ab-lightbox-close" onClick={toggleLightbox} aria-label="Close lightbox">&times;</button>
          </div>
        </div>
      )}
    </main>
  );
};

export default AboutPage;
